export const isCardItem = (item) => {
    return item.id !== undefined;
};
export const isDetachedCardItem = (item) => {
    return item.id === undefined;
};
